export default class Hotspot {
    constructor(element) {
        this.domElement = element
        this.activeClass = 'hotspot--active'
    }

    get triggerElement() {
        return this.domElement.querySelector('.js-hotspot__trigger')
    }

    get closeElement() {
        return this.domElement.querySelector('.js-hotspot--close')
    }

    close() {
        this.domElement.classList.remove(this.activeClass)
    }

    open() {
        this.domElement.classList.add(this.activeClass)
    }
}
